var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "15 0 200 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,246.000000) scale(0.110000,-0.110000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506 2224 c-14 -14 -16 -95 -16 -748 0 -661 2 -735 16 -747 9 -7 45     -15 80 -17 l64 -4 0 -217 c0 -172 3 -221 14 -237 14 -18 31 -19 388 -21 314     -2 377 0 396 13 21 14 22 19 22 187 0 94 -4 177 -8 183 -14 22 -48 25 -65 6     -13 -14 -17 -45 -19 -157 l-3 -140 -45 0 -45 0 0 195 0 195 167 5 c91 3 170 9     175 13 4 5 8 338 8 741 0 607 -2 736 -14 749 -12 15 -64 17 -557 17 -480 0     -544 -2 -558 -16z m1034 -744 l0 -670 -35 0 c-19 -1 -217 -1 -440 -1 -223 0     -423 0 -445 1 l-40 0 0 670 0 670 480 0 480 0 0 -670z m-352 -957 l-3 -198     -220 0 -220 0 -3 185 c-1 101 0 190 2 197 4 10 56 13 226 13 l220 0 -2 -197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 1933 c-11 -12 -14 -55 -14 -178 0 -123 3 -166 14 -178 12 -15     49 -17 347 -17 319 0 334 1 344 19 15 29 13 344 -2 359 -9 9 -99 12 -344 12     -296 0 -333 -2 -345 -17z m584 -73 l27 0 0 -105 0 -105 -265 0 -265 0 0 104 0     105 33 3 c25 2 286 2 470 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 2001 c-6 -13 -10 -195 -10 -523 0 -440 2 -506 16 -526 17 -24     43 -29 62 -10 9 9 12 142 12 539 0 471 -2 528 -16 533 -29 11 -53 6 -64 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetManagement);
export default __webpack_public_path__ + "static/media/AssetManagement.0c0689534577a8803390a8f17b85f17b.svg";
export { ForwardRef as ReactComponent };